import React from "react";

import panIcon from "./../../../img/icons/panierIcon.svg";
import { Localized } from "fluent-react/compat";

const DisplayModuleAvailable = ({
  screenDesktop,
  errorMessage,
  dataMessage,
  textMessage,
}) => {
  return (
    <div className="container-display-hour-app-open">
      {screenDesktop ? <img src={panIcon} style={{marginRight: 10 }} /> : ""}
      {errorMessage === "tr-service-closed" ? (
        <p>
          <Localized id="tr-service-closed" />
        </p>
      ) : (
        <>
          <p style={{ paddingLeft: 0 }}>
            <Localized id={textMessage} />
            <span className="display-hour-available">{dataMessage}</span>
          </p>
        </>
      )}
    </div>
  );
};

export default DisplayModuleAvailable;
